// extracted by mini-css-extract-plugin
export default {"root":"oWPmM__root","flickityCarouselContainer":"_jwzT__flickityCarouselContainer flickity-carousel-container"};